class EventFunctionController {
    constructor($http, $window, $timeout) {
        'ngInject';
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.errorMessage = '';

        this.spinner = true;
        this.error = false;
    }

    $onInit() {
        this.$timeout(() => {
            this.$http({
                url: '/api/sitecore/IsacaCatalog/GetAccountCodes',
                method: 'GET'
            }).then((response) => {
                this.data = response.data;
                // if(response.data.Success === 'true' || response.data.Success === 'True') {
                //     this.data = response.data.Data;
                // } else {
                //     this.errorMessage = response.data.Message;
                //     this.error = true;
                // }
                this.spinner = false;
            }, (response) => {
                this.errorMessage = 'There was a error with fetching your data.';
                this.spinner = false;
                this.error = true;
                console.log(response);
            });
        }, 1000);
    }
}

export default EventFunctionController;



// WEBPACK FOOTER //
// ./src/app/angular/event-function/event-function.controller.js